import css from 'styled-jsx/css';

const styles = css.global`.blog-texto p,
.blog-texto p b,
.blog-texto p .blog-disclaimer,
.blog-texto h4 {
  /* max-width: 288px; */
  color: #444444;
  font-family: 'SantanderText', sans-serif;
  font-size: 17px;
  letter-spacing: 0;
  line-height: 25px;
  text-align: justify;
  margin: 0 0 24px 0;
}

.blog-texto p .aling-left {
  text-align: left;
}

.blog-texto p b {
  font-weight: 600!important;
}

.blog-texto p b.red {
  color: #cc0000;
}
.blog-texto p i {
  font-style: italic
}

.blog-texto p a,
.blog-texto h4 a {
  color: #cc0000;
  font-family: 'SantanderText';
  text-decoration: underline;
  cursor: pointer;
}

.blog-texto p .blog-disclaimer {
  font-size: 14px;
  line-height: 18px;
  display: block
}

.blog-texto p .quadros-blog {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 15px;
  justify-content: center;
}

.blog-texto p .quadros-blog .quadro-blog {
  width: 180px;
  text-align: center;
  border: 1px solid #222222;
  border-radius: 4px;
  padding: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.blog-texto p .quadros-blog .quadro-blog b {
  text-align: center;
  margin: 0;
}

.blog-texto p .quadros-blog .quadro-blog strong {
  color: #444;
  font-family: "SantanderText", sans-serif;
  font-size: 17px;
  letter-spacing: 0;
  line-height: 25px;
}

.border-blog {
  border: 1px solid #222;
  margin-bottom: 10px;
  padding: 5px;
}

.blog-texto h2,
.blog-texto h3 {
  /* max-width: 288px; */
  color: #222222;
  font-family: 'SantanderHeadline';
  font-size: 18px;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
  text-align: left;
  margin: 0 0 24px 0;
  font-weight: normal;
}

.blog-texto h2 {
  font-size: 22px;
}

.blog-texto h2 b {
  font-weight: 900!important;
}

.blog-texto legend {
  font-size: 14px;
}

.blog-texto p .no-justify {
  text-align: initial;
  display: inline-block;
}
/* 
.flex .quadro-blog {
  display: flex;
  align-items: center!important;
  justify-content: center!important;
} */

.extendido {
  width: 100%!important;
  max-width: 700px;
}

@media (min-width: 992px) {
  .blog-texto p,
  .blog-texto p .blog-disclaimer {
    max-width: 757px;
    color: #444444;
  }

  .blog-texto p .quadros-blog {
    flex-wrap: nowrap;
  }

  .blog-texto h2,
  .blog-texto h3 {
    max-width: 691px;
    color: #222222;
    font-family: 'SantanderHeadline';
    font-size: 18px;
    letter-spacing: 0;
    line-height: 36px;
    font-weight: normal;
  }

  .blog-texto h3 {
    line-height: 26px;
  }

  .blog-texto h2 {
    font-size: 26px;
  }
}
`;

export default styles;